{
  "name": "heavy-knife",
  "_note": "무거운 칼. 관통 걸림이 크고 진행 저항이 높아 칼날이 손가락보다 눈에 띄게 뒤처진다. 소리는 낮고 굵게.",
  "cut": {
    "bladeStiffness": 14,
    "bladeDamping": 1.4,
    "penetrationResistance": 5.0,
    "penetrationDepth": 0.3,
    "baseResistance": 1.6,
    "stickRatio": 1.5,
    "jitterAmount": 0.55,
    "jitterFreq": 4,
    "velEffect": 0.09,
    "gapAmount": 0.22
  },
  "sound": {
    "cut": { "freqMin": 500, "freqMax": 2400, "q": 0.9 },
    "crackle": { "rateMax": 90, "durMax": 0.008 },
    "penetrate": { "freq": 900, "dur": 0.05 },
    "complete": { "freq": 450, "dur": 0.09 }
  }
}
